
import { Link, type LinksFunction } from 'react-router';
import styles from './hero.css?url';

export default function HeroSection() {
    
    return (
        <>
            <section id="hero" className={`d-flex justify-content-center align-items-center style1 style2 style4`}>
                <div
                    className={`container position-relative style3`}
                    data-aos="zoom-in"
                    data-aos-delay="100">
                    <h1>First Aid & Mental Health Training That Your Staff Will Actually Remember</h1>
                    <h2>On-site courses built around your workplace, your risks, and your people — delivered anywhere in the UK</h2>
                    <Link className="btn-get-started" to='/training-discussion'>Request a Training Discussion</Link>
                    
                </div>
            </section>
        </>
    )
}

export const links: LinksFunction = () => [
    { rel: "stylesheet", href: styles },
];